import { NodeExtension, ParamType } from 'helicon';
import { TriggeredSamplerNode } from './TriggeredSamplerNode';

export const TriggeredSampler: NodeExtension = {
  type: 'TriggeredSamplerNode',
  node: TriggeredSamplerNode,
  description: {
    numberOfInputs: 0,
    numberOfOutputs: 1,
    params: {
      buffer: {
        type: ParamType.AudioBuffer,
        default: null,
        writeOnce: false,
      },
      clock: { type: ParamType.AudioParam, default: 0 },
      detune: {
        type: ParamType.AudioParam,
        unit: 'cents',
        default: 0,
      },
    },
  },
  processor: '/TriggeredSamplerProcessor.js',
};
